import { z } from 'zod'
import ClientLogger from '@eversports/react-components/utilities/client-logger'
import { ClientMetadataPlatform } from '../typings/ClientMetadata'
import { GCLID_STORAGE_KEY } from './gclid.constants'

const CLIENT_METADATA_STORAGE_KEY = 'clientMetadata'

const ClientMetadataSchema = z.object({
  isBrandedApp: z.coerce.boolean().optional(),
  platform: z.nativeEnum(ClientMetadataPlatform).optional(),
})

function getGclid(): string | undefined {
  const storedGclid = window.sessionStorage.getItem(GCLID_STORAGE_KEY)
  if (storedGclid) return storedGclid

  const gclidFromUrl = new URLSearchParams(window.location.search).get(GCLID_STORAGE_KEY)
  if (!gclidFromUrl) return undefined

  try {
    window.sessionStorage.setItem(GCLID_STORAGE_KEY, gclidFromUrl)
  } catch (error) {}

  return gclidFromUrl
}

export function getClientMetadata() {
  if (typeof window === 'undefined') return null

  const gclid = getGclid()
  const data = window.sessionStorage.getItem(CLIENT_METADATA_STORAGE_KEY)

  if (!data) {
    return gclid ? { gclid } : null
  }

  try {
    const clientMetadata = ClientMetadataSchema.parse(JSON.parse(data))
    return { ...clientMetadata, gclid }
  } catch (error) {
    if (error instanceof z.ZodError) {
      ClientLogger.error('Failed to parse client metadata', {
        issues: error.issues,
        data,
      })
    } else {
      ClientLogger.error('Error parsing client metadata', { error, data })
    }
    return gclid ? { gclid } : null
  }
}
